import { inject, Injectable } from '@angular/core';
import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  ResolveFn,
} from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { catchError, Observable, of, tap } from 'rxjs';

@Injectable()

/////// PLEASE BE AWARE - this guard should only be applied to public pages where we don't want logged in user to proceed with an action that require to be logged out such as confirm email, password etc. ///////

export class LoggedinGuard {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) {}

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    this.authenticationService.verifyActiveToken().subscribe({
      next: (loggedIn) => {
        this.authenticationService.isUserLoggedin.next(loggedIn);
        if (loggedIn) {
          this.router.navigate(['/dashboard']);
          return false;
        } else {
          return true;
        }
      },
      error: () => {
        this.authenticationService.isUserLoggedin.next(false);
        // Return true to indicate the user is not logged in and proceed to the page
        return true;
      },
    });
  }
}



export const LoggedinResolver: ResolveFn<boolean> = (): Observable<boolean> => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);

  return authService.verifyActiveToken().pipe(
    tap( res => res ? router.navigate(['/dashboard']) : null), // Navigate to dashboard if logged in
    catchError(() => of(null) // Return an observable of null to indicate the user is not logged in
    )
  );
};